<template>
  <b-card>
    <b-form @submit.prevent="updateFile">
      <b-row>
        <b-col sm="6">
          <b-form-group label="Portfolio *" label-for="category"> 
            <b-form-select v-model="form.category" :options="productCategories"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="Type *" label-for="type"> 
            <b-form-select v-model="form.type" :options="productType"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="Document Date *" label-for="documentCreatedAt">
            <date-picker 
                v-model="form.date"
                type="date" 
                :valueType="'format'"
                placeholder="Date"
                class="w-100 datePicker"
                @panel-change="onPanelChange"
              />  
            <!-- <b-form-datepicker v-model="form.date" id="date" placeholder="Date" class="w-100 datePicker"/> -->
          </b-form-group>
        </b-col>
        <b-col sm="6" class="mb-3">
          <b-form-group label="Upload File" label-for="file">
            <b-form-file
              v-model="form.file"
              :state="Boolean(form.file)"
              placeholder="Drag and drop your file here or click to select"
              accept=".pdf"
              ref="file-input"
              @dragover.prevent
              @drop.prevent="handleFileUpload"
              @change="handleFileUpload"
            ></b-form-file>
            <p v-if="form.fileName"><b><i>{{ form.fileName }}</i></b></p>
            <b-alert 
              v-if="errorMessage" 
              variant="danger"
              show
              style="width:100%" 
            >
              {{ errorMessage }}
            </b-alert>
          </b-form-group>
        </b-col>
        <b-col class="d-flex justify-content-end">
          <b-button type="button" @click="goBack" class="mr-1" variant="light">
            Cancel
          </b-button>
          <b-button type="submit" :disabled="isLoading" variant="primary">
            Save
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BCard,
  BFormInput,
  BButton,
  BForm,
  BFormFile,
  BFormDatepicker,
  BFormSelect,
  BAlert
} from 'bootstrap-vue'
import { generateToken } from '@/auth/helperAuth'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import moment from "moment";

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BCard,
    BFormInput,
    BFormFile,
    BButton,
    BForm,
    BFormDatepicker,
    DatePicker,
    BFormSelect,
    BAlert,
    moment
  },
  data() {
    return {
      token: '',
      productCategories: [],
      productType: [
        {value: "Penetapan", text:"Penetapan"},
        {value: "GTM", text:"GTM"},
        {value: "Retirement", text:"Retirement"},
      ],
      isLoading: false,
      form: {
        date: null,
        file: null,
        category: '',
        type: '',
        fileName: '',
      },
      initialForm: {},
      errorMessage: ""
    }
  },
  mounted() {
    const id = this.$route.params.key
    this.loadNotaDinasData(id)
    Promise.all([
      this.getProductCategory()
    ])
  },
  created() {
    // this.initialForm = JSON.parse(JSON.stringify(this.form))
    const payload = {
      client: "product-catalog-fe",
      kode: this.$store.getters['oauth/getActiveUser'].id.toString(),
      user: this.$store.getters['oauth/getActiveUser'].name,
      role: this.$store.getters['oauth/getActiveUser'].role,
    };
    this.token = generateToken(payload)
  },
  destroyed() {},
  computed: {
    formattedDate: {
      get() {
        return this.form.date
          ? moment(this.form.date).format("YYYY-MM-DD")
          : null
      },
      set(value) {
        this.form.date = moment(value, "YYYY-MM-DD").toDate()
      },
    },
  },
  methods: {
    customFormatter(date) {
      return moment(date).format('YYYY-MM-DD')
    },
    onPanelChange(panel) { 
      if (panel === 'year') {
        this.$nextTick(() => { 
          const btnLeft = document.querySelector('.mx-btn-icon-double-left')
          const btnRight = document.querySelector('.mx-btn-icon-double-right')
          $(btnLeft).click(() => {
            const yearCells = document.querySelectorAll('.mx-calendar-content .mx-table-year .cell');
            yearCells.forEach(cell => { 
              const currentYear = new Date().getFullYear()
              const year = parseInt(cell.getAttribute('data-year'))
              if (year < 2000 || year > currentYear) { 
                cell.classList.add('disabled')
              } else { 
                cell.classList.remove('disabled')
              }
            })
          })
          $(btnRight).click(() => {
            const yearCells = document.querySelectorAll('.mx-calendar-content .mx-table-year .cell');
            yearCells.forEach(cell => { 
              const currentYear = new Date().getFullYear(); 
              const year = parseInt(cell.getAttribute('data-year'))
              if (year < 2000 || year > currentYear) { 
                cell.classList.add('disabled')
              } else { 
                cell.classList.remove('disabled')
              }
            })
          })
          const yearCells = document.querySelectorAll('.mx-calendar-content .mx-table-year .cell');
            yearCells.forEach(cell => { 
              const currentYear = new Date().getFullYear(); 
              const year = parseInt(cell.getAttribute('data-year'))
              if (year < 2000 || year > currentYear) { 
                cell.classList.add('disabled')
              } else { 
                cell.classList.remove('disabled')
              }
            })
          })
        }
    },
    async getProductCategory() {
      return await this.$http.get(`/product-category/take/all`)
      .then( res => {
        for(let i of res.data.data.records){
          this.productCategories.push({
            text: i.name,
            value: i.name
          })
        }
      })
      .catch( err => {
        console.error(err)
      })
    },
    handleFileUpload(event) {
      let files
      if (event.dataTransfer) {
        files = event.dataTransfer.files
      } else if (event.target.files) {
        files = event.target.files
      }

      if (files && files.length) {
        const file = files[0]
        const validMimeType = "application/pdf"
        if (file.type !== validMimeType) {
          this.$refs["file-input"].reset()
          this.form.file = null
          this.errorMessage = "Hanya file PDF yang diperbolehkan!"
        } else {
          this.form.file = file
          this.errorMessage = ""
        }
      }
    },
    loadNotaDinasData(id) {
      this.$http
        .get(`${process.env.VUE_APP_API_HELPER_URL}/attachment/list?id=${id}&page=1&perPage=10`, {
          params: { type: 'NotaDinas' },
          withCredentials: false,
          headers: {'Client-Device': 'browser', 'Authorization': `${this.token}`}
        })
        .then(({ data }) => {
          this.form = {
            category: data.data[0].category,
            type: data.data[0].type_nd,
            date: data.data[0].date,
            fileName:  data.data[0].name
          }
          this.initialForm = {
            category: this.form.category,
            type: this.form.type,
            date: this.form.date,
            fileName:  this.form.fileName
          }
        })
        .finally(() => {})
    },
    async updateFile() {
      const formData = new FormData()
      formData.append('id', this.$route.params.key)
      if (this.form.category !== this.initialForm.category) {
        formData.append('category', this.form.category)
      }
      if (this.form.type !== this.initialForm.type) {
        formData.append('type', this.form.type)
      }
      if (this.form.date !== this.initialForm.date) {
        formData.append('date', this.form.date)
      }
      if (this.form.file) {
        formData.append('file', this.form.file)
      }

      this.$http
        .put(`${process.env.VUE_APP_API_HELPER_URL}/attachment/notaDinas/update`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Accept': 'application/json',
            'Client-Device': 'browser',
            'Authorization': `${this.token}`
          },
          withCredentials: false,
        })
        .then(res => {
          this.load = res
          this.$refs['file-input'].reset()
          this.$notif('Success', 'Successfully update Nota Dinas', 'success')
          this.$router.push('/admin/notadinas')
        })
        .catch(err => {
          if (typeof err.data.errors !== 'undefined') {
            this.$notif('Error', err.data.errors.file[0], 'error')
          }else{
            this.errString = err.data.replace(",","<br>")
            this.$notif('Error', `Something wrong`, 'error')
          }
        })
        .finally(() => (this.isLoading = false))
    },
    goBack() {
      window.history.go(-1)
    }
  }
}
</script>

<style>

.datePicker .dropdown-menu {
  z-index: 1050;
}
</style>